import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    Router,
    RouterStateSnapshot,
} from '@angular/router';
import { SessionService } from '@app/core/services/client-services/session-service/session.service';
import { AuthService } from '@app/core/services/auth.service';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard {
    constructor(
        public sessionService: SessionService,
        private authService: AuthService,
        private router: Router
    ) {}

    async canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean> {
        // Check if user session already exists and is valid
        const existingSession = this.sessionService.getSession();
        if (existingSession?._key) {
            // Check terms of service for existing session
            if (
                existingSession.termsOfService &&
                !existingSession.termsOfService.accepted
            ) {
                if (
                    existingSession.termsOfService.dateAcceptUntil &&
                    existingSession.termsOfService.dateAcceptUntil <
                        new Date().getTime()
                ) {
                    this.router.navigate(['/settings/tos']);
                    return false;
                }
            }

            return true;
        }

        // No cached session -- try loading from API (relies on DLS_SESSION_ID cookie)
        try {
            await this.sessionService.loadUserFromApi();

            // Check terms of service for new user data
            const userData = this.sessionService.getSession();
            if (userData?.termsOfService && !userData.termsOfService.accepted) {
                if (
                    userData.termsOfService.dateAcceptUntil &&
                    userData.termsOfService.dateAcceptUntil <
                        new Date().getTime()
                ) {
                    this.router.navigate(['/settings/tos']);
                    return false;
                }
            }

            return true;
        } catch (error) {
            // /me returned 401 or failed -- redirect to BFF login
            this.authService.initLogin(state.url);
            return false;
        }
    }
}
